import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { buildDetailSlug } from '@/utils/detailSlug';
interface RecommendHometownNewsVerticalCardProps {
  className?: string;
  daysAgo: string;
  idIdx: string;
  name: string;
  thumbnail: string;
  slugId?: string;
}
export const RecommendHometownNewsVerticalCard = t0 => {
  const $ = _c(21);
  const {
    className,
    daysAgo,
    idIdx,
    name,
    thumbnail,
    slugId
  } = t0;
  let t1;
  if ($[0] !== idIdx || $[1] !== name || $[2] !== slugId) {
    t1 = ROUTES.HOMETOWN_NEWS_DETAIL.pathname({
      idIdx: buildDetailSlug(idIdx, name, slugId)
    });
    $[0] = idIdx;
    $[1] = name;
    $[2] = slugId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const routePathname = t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("flex h-244 w-161 flex-col gap-10", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== name || $[7] !== thumbnail) {
    t3 = <Image alt={name} className="size-160 rounded-small border border-Gray-300 object-cover" height={160} src={thumbnail} width={160} />;
    $[6] = name;
    $[7] = thumbnail;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== name) {
    t4 = <h4 className="line-clamp-2 text-ellipsis break-all font-500 text-Gray-900 typo-body3">{name}</h4>;
    $[9] = name;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== daysAgo) {
    t5 = <p className="font-400 text-Gray-600 typo-caption1">{daysAgo}</p>;
    $[11] = daysAgo;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <section className="flex h-73 flex-col justify-between gap-6">{t4}{t5}</section>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== routePathname || $[17] !== t2 || $[18] !== t3 || $[19] !== t6) {
    t7 = <CustomLink className={t2} href={routePathname}>{t3}{t6}</CustomLink>;
    $[16] = routePathname;
    $[17] = t2;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};